import * as i18next from 'i18next';

import { CellRenderer, MainColumns } from '../../../../components/TableGrid';
import { ColumnPreset } from '../../../../components/TableGrid/Presets/ColumnPresets';

export function SearchListColumns(
  t: i18next.TFunction,
  sortingAllowed: boolean,
  benchmarkId?: string,
) {
  return [
    {
      headerName: `${t('companies:columns:number')}`,
      field: 'rowIndex',
      minWidth: 90,
      unSortIcon: true,
      sortable: false,
      cellRenderer: CellRenderer.RowIndex,
    },
    {
      headerName: `${t('companies:columns:companyName')}`,
      field: 'companyInfo.name',
      minWidth: 300,
      unSortIcon: true,
      sortable: sortingAllowed,
      cellRenderer: CellRenderer.Link,
      cellRendererParams: {
        benchmarkId: benchmarkId,
      },
    },
    {
      headerName: `${t('companies:columns:country')}`,
      field: 'companyInfo.country',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
    },
    {
      headerName: `${t('companies:columns:companyNumber')}`,
      field: 'companyInfo.companyNumber',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
    },
    {
      headerName: `${t('companies:columns:status')}`,
      field: 'companyInfo.statuses',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
    },
    {
      headerName: `${t('companies:columns:legalForm')}`,
      field: 'companyInfo.legalForm',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:employeeAverage')}`,
      field: 'financialInfo.employeeAverage',
      minWidth: 200,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:fte')}`,
      field: 'financialInfo.fte',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:dateOfIncorporation')}`,
      field: 'companyInfo.startDate',
      minWidth: 170,
      unSortIcon: true,
      sortable: sortingAllowed,
    },
    {
      headerName: `${t('companies:columns:cessationDate')}`,
      field: 'companyInfo.cessationDate',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:address')}`,
      field: 'companyInfo.address.address',
      minWidth: 300,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.CompanyAddress,
      cellClass: 'multipleLineCell',
    },
    {
      headerName: `${t('companies:columns:emailAddress')}`,
      field: 'companyInfo.emailAddresses',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:website')}`,
      field: 'companyInfo.websites',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      cellRenderer: CellRenderer.ExternalLink,
    },
    {
      headerName: `${t('companies:columns:phone')}`,
      field: 'companyInfo.phones',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:socials')}`,
      field: 'companyInfo.socials',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      cellRenderer: CellRenderer.ExternalLink,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:vatNumber')}`,
      field: 'companyInfo.vatNumber',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:primaryNaceCode')}`,
      field: 'companyInfo.primaryNaceCode',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:secondaryNaceCode')}`,
      field: 'companyInfo.secondaryNaceCode',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:primarySicCode')}`,
      field: 'companyInfo.primarySicCode',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:secondarySicCode')}`,
      field: 'companyInfo.secondarySicCode',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:description')}`,
      field: 'companyInfo.descriptions',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:keywords')}`,
      field: 'companyInfo.keywords',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:topShareHolders')}`,
      field: 'companyInfo.topShareHolders',
      minWidth: 250,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.TopShareHolders,
      cellClass: 'multipleLineCell',
    },
    {
      headerName: `${t('companies:columns:currencyOfAccounts')}`,
      field: 'companyInfo.currencyOfAccounts',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:lastAvailableYear')}`,
      field: 'companyInfo.lastAvailableYear',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:financialYearEnd')}`,
      field: 'companyInfo.financialYearEnd',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:typeOfAccounts')}`,
      field: 'companyInfo.typeOfAccounts',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:accountingStandard')}`,
      field: 'companyInfo.accountingStandard',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
    },
    {
      headerName: `${t('companies:columns:reportingPeriod')}`,
      field: 'financialInfo.reportingPeriod',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:consolidation')}`,
      field: 'financialInfo.consolidation',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:turnover')}`,
      field: 'financialInfo.turnover',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:otherOperatingIncome')}`,
      field: 'financialInfo.otherOperatingIncome',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },

    {
      headerName: `${t('companies:columns:otherOperatingExpense')}`,
      field: 'financialInfo.otherOperatingExpense',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:costOfGoodsSold')}`,
      field: 'financialInfo.costOfGoodsSold',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:grossProfitLoss')}`,
      field: 'financialInfo.grossProfitLoss',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:operatingExpenses')}`,
      field: 'financialInfo.operatingExpenses',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:ebitda')}`,
      field: 'financialInfo.ebitda',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:operatingProfitLoss')}`,
      field: 'financialInfo.operatingProfitLoss',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:financialIncome')}`,
      field: 'financialInfo.financialIncome',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:financialExpense')}`,
      field: 'financialInfo.financialExpense',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:financingNetResult')}`,
      field: 'financialInfo.financingNetResult',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:profitLossBeforeTax')}`,
      field: 'financialInfo.profitLossBeforeTax',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:taxOnProfit')}`,
      field: 'financialInfo.taxOnProfit',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:profitLossAfterTax')}`,
      field: 'financialInfo.profitLossAfterTax',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:dividends')}`,
      field: 'financialInfo.dividends',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:retainedEarnings')}`,
      field: 'financialInfo.retainedEarnings',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:rndExpense')}`,
      field: 'financialInfo.rndExpense',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:fixedAssets')}`,
      field: 'financialInfo.fixedAssets',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:intangibleFixedAssets')}`,
      field: 'financialInfo.intangibleFixedAssets',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:tangibleFixedAssets')}`,
      field: 'financialInfo.tangibleFixedAssets',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:otherFixedAssets')}`,
      field: 'financialInfo.otherFixedAssets',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:currentAssets')}`,
      field: 'financialInfo.currentAssets',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:stock')}`,
      field: 'financialInfo.stock',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:debtors')}`,
      field: 'financialInfo.debtors',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:otherCurrentAssets')}`,
      field: 'financialInfo.otherCurrentAssets',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },

    {
      headerName: `${t('companies:columns:cashAndCashEquivalents')}`,
      field: 'financialInfo.cashAndCashEquivalents',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:totalAssets')}`,
      field: 'financialInfo.totalAssets',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:shareholdersFunds')}`,
      field: 'financialInfo.shareholdersFunds',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:shareCapital')}`,
      field: 'financialInfo.shareCapital',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:otherShareholdersFunds')}`,
      field: 'financialInfo.otherShareholdersFunds',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:nonCurrentLiabilities')}`,
      field: 'financialInfo.nonCurrentLiabilities',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:longTermDebt')}`,
      field: 'financialInfo.longTermDebt',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:otherNonCurrentLiabilities')}`,
      field: 'financialInfo.otherNonCurrentLiabilities',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:provisions')}`,
      field: 'financialInfo.provisions',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },

    {
      headerName: `${t('companies:columns:currentLiabilities')}`,
      field: 'financialInfo.currentLiabilities',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:shortTermLoans')}`,
      field: 'financialInfo.shortTermLoans',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:creditors')}`,
      field: 'financialInfo.creditors',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:otherCurrentLiabilities')}`,
      field: 'financialInfo.otherCurrentLiabilities',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:totalShareholdersFundsAndLiabilities')}`,
      field: 'financialInfo.totalShareholdersFundsAndLiabilities',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:cashFlow')}`,
      field: 'financialInfo.cashFlow',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:intangibleFixedAssetsTotalAssets')}`,
      field: 'financialInfo.intangibleFixedAssetsTotalAssets',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:intangibleFixedAssetsTurnover')}`,
      field: 'financialInfo.intangibleFixedAssetsTurnover',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:tangibleFixedAssetsTotalAssets')}`,
      field: 'financialInfo.tangibleFixedAssetsTotalAssets',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:tangibleFixedAssetsTurnover')}`,
      field: 'financialInfo.tangibleFixedAssetsTurnover',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:debtorsTurnover')}`,
      field: 'financialInfo.debtorsTurnover',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:stockTotalAssets')}`,
      field: 'financialInfo.stockTotalAssets',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:stockTurnover')}`,
      field: 'financialInfo.stockTurnover',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:currentLiabilitiesCostOfGoodsSold')}`,
      field: 'financialInfo.currentLiabilitiesCostOfGoodsSold',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:currentLiabilitiesDebtors')}`,
      field: 'financialInfo.currentLiabilitiesDebtors',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:grossMargin')}`,
      field: 'financialInfo.grossMargin',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:returnOnCapital')}`,
      field: 'financialInfo.returnOnCapital',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:returnOnTotalAssets')}`,
      field: 'financialInfo.returnOnTotalAssets',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:netProfitMargin')}`,
      field: 'financialInfo.netProfitMargin',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:profitLossBeforeTaxNumberOfEmployees')}`,
      field: 'financialInfo.profitLossBeforeTaxNumberOfEmployees',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:grossMarkUp')}`,
      field: 'financialInfo.grossMarkUp',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:berryRatio')}`,
      field: 'financialInfo.berryRatio',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:ebitMargin')}`,
      field: 'financialInfo.ebitMargin',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:netCostPlus')}`,
      field: 'financialInfo.netCostPlus',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:rndExpenseRatio')}`,
      field: 'financialInfo.rndExpenseRatio',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:ebitdaDebtRatio')}`,
      field: 'financialInfo.ebitdaDebtRatio',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:liquidityRatio')}`,
      field: 'financialInfo.liquidityRatio',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:solvencyRatio')}`,
      field: 'financialInfo.solvencyRatio',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:stockCostOfGoodsSold')}`,
      field: 'financialInfo.stockCostOfGoodsSold',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:tpAdjustedTurnover')}`,
      field: 'financialInfo.tpAdjustedTurnover',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:tpAdjustedCostOfGoodsSold')}`,
      field: 'financialInfo.tpAdjustedCostOfGoodsSold',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:tpAdjustedGrossProfitLoss')}`,
      field: 'financialInfo.tpAdjustedGrossProfitLoss',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:tpAdjustedOperatingExpenses')}`,
      field: 'financialInfo.tpAdjustedOperatingExpenses',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
    {
      headerName: `${t('companies:columns:tpAdjustedOperatingProfitLossEbit')}`,
      field: 'financialInfo.tpAdjustedOperatingProfitLossEbit',
      minWidth: 150,
      unSortIcon: true,
      sortable: sortingAllowed,
      hide: true,
      cellRenderer: CellRenderer.YearWithValue,
    },
  ] as MainColumns[];
}

export function searchListDefaultColumns(): string[] {
  return [
    'rowIndex',
    'companyInfo.name',
    'companyInfo.country',
    'companyInfo.companyNumber',
    'companyInfo.statuses',
    'companyInfo.startDate',
    'companyInfo.websites',
    'financialInfo.turnover',
    'financialInfo.totalAssets',
  ];
}

export function searchExportDefaultColumns(): string[] {
  return [
    'rowIndex',
    'companyInfo.name',
    'companyInfo.country',
    'companyInfo.companyNumber',
    'companyInfo.statuses',
    'companyInfo.legalForm',
    'companyInfo.startDate',
    'companyInfo.websites',
    'financialInfo.employeeAverage',
    'financialInfo.turnover',
    'financialInfo.totalAssets',
  ];
}

export function searchListColumnPresets(): ColumnPreset[] {
  return [
    {
      label: 'TNMM',
      fields: [
        'companyInfo.name',
        'companyInfo.descriptions',
        'financialInfo.operatingProfitLoss',
        'financialInfo.ebitMargin',
        'financialInfo.netCostPlus',
        'financialInfo.rndExpenseRatio',
      ],
    },
    {
      label: 'Qualitative',
      fields: [
        'companyInfo.name',
        'companyInfo.country',
        'companyInfo.primaryNaceCode',
        'companyInfo.primarySicCode',
        'companyInfo.descriptions',
        'companyInfo.websites',
      ],
    },
  ];
}

export default SearchListColumns;
